<template>
  <div class="boxLogin">
    <div class="title">欢迎注册</div>
    <div class="line">
      <div class="lineRight">
        <el-input type="primary" v-model="username" size="small" placeholder="请输入账号"></el-input>
      </div>
    </div>
    <div class="line">
      <div class="lineRight">
        <el-input type="password" v-model="password" size="small" placeholder="请输入密码"></el-input>
      </div>
    </div>
    <div class="buttonBox">
      <el-button @click="doLoginMy" type="primary" style="border:none;background-color: #1d8d05;width: 100%;margin: 0;" :disabled="registerDis">
        注册
      </el-button>
      <el-button type="primary" style="width: 100%;margin: 0;margin-top: 7px" @click="toLogin">
        去登陆
      </el-button>
      <el-button type="primary" style="width: 100%;margin: 0;margin-top: 7px" @click="closeMy">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import {sendYzm} from "@/api/qt/sendYzm";
import {Message} from "element-ui";
import {doRegister} from "@/api/qt/login";
import router from "@/router";

export default {
  data(){
    return {
      username:"",
      password:"",
      email:"",
      mobile:"",
      code:"",
      yuTime:0,
      sendYzmOpen:true,
      userInfo:{},
      registerDis:false
    }
  },

  methods: {
    toLogin(){
      console.log("去登录")
      this.$emit("closeLogin")
      this.$emit("openLogin")
    },
    closeMy(){
      this.$emit("closeLogin")
    },
    doLoginMy(){
      this.registerDis=true
      let timer=setTimeout(()=>{
        this.registerDis=false
      },3000)
      //携带代理id
      let amdinId=localStorage.getItem('adminId')

      doRegister(this.username,this.password,amdinId).then(res=>{
        let data=res.data;
        clearTimeout(timer);
        this.registerDis=false;
        if(data.code==1){
          this.closeMy()
          Message("注册成功")
          this.$emit("openLogin")
        }else{
          Message(data.msg)
        }
      })
    },
    async sendYzmMy(){
      // if(this.username==""){
      //   Message("请输入用户名");
      //   return;
      // }
      // if(this.password==""){
      //   Message("请输入密码");
      //   return;
      // }
      // if(this.email==""){
      //   Message("请输入邮箱");
      //   return;
      // }
      if(this.mobile==""){
        Message("请输入手机号");
        return;
      }
      // if(this.code==""){
      //   Message("请输入验证码");
      //   return;
      // }
      if(this.sendYzmOpen==false){
        return;
      }
      this.sendYzmOpen=false;
      let re=await sendYzm(this.mobile)
      console.log(re,"发送验证码返回")
      this.yuTime=60;
      let timer=setInterval(()=>{
        this.yuTime--;
        if(this.yuTime==0){
          this.sendYzmOpen=true;
          clearInterval(timer)
        }
      },1000)
    }
  }
}
</script>
<style scoped>
.lineRight1{
  width:90px;
  font-size: 14px;
  padding-left: 10px;
  box-sizing: border-box;
  color:#aaa;
  cursor: pointer;
}
.title{
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color:#fff;
}
.boxLogin{
  width: 400px;
  position: fixed;
  left:calc(50% - 200px);
  top:200px;
  background-color: rgba(44,62,80,0.9);
  padding: 20px;
  border-radius: 10px;
  z-index:111111111;
}
.line{
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.buttonBox{
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.line > span{
  width:70px;
  text-align: right;
  padding-right: 10px;
  box-sizing: border-box;
  font-size: 14px;
}
.lineRight{
  width:1px;
  flex:1;
}
</style>
